import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { rootRoute } from "./root";

export const referralRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/$locale/referral/$code",
  component: lazyRouteComponent(() => import("../pages/referral")),
});
